module.exports = __webpack_public_path__ + "static/img/14000366.fb50ddf3.png";